export const API_BASE = 'https://sound-wave.b.goit.study/api';
export const DEFAULT_PAGE = 1;
export const ARTISTS_PAGE_LIMIT = 8;
export const REQUEST_TIMEOUT_MS = 10_000;
export const FEEDBACKS_LIMIT = 10;
